import * as Headless from "@headlessui/react";
import clsx from "clsx";
import { useState, useRef, useEffect } from "react";

export function Tooltip({
  content,
  children,
  className,
  position = "top",
}: {
  content: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  position?: "top" | "bottom" | "left" | "right";
}) {
  const [isOpen, setIsOpen] = useState(false);
  const timeout = useRef<NodeJS.Timeout | null>(null);

  const show = () => {
    if (timeout.current) clearTimeout(timeout.current);
    setIsOpen(true);
  };

  const hide = () => {
    timeout.current = setTimeout(() => setIsOpen(false), 100);
  };

  useEffect(() => {
    return () => {
      if (timeout.current) clearTimeout(timeout.current);
    };
  }, []);

  return (
    <Headless.Popover className="relative inline-block text-left">
      <Headless.Popover.Button
        as="span"
        onMouseEnter={show}
        onMouseLeave={hide}
      >
        {children}
      </Headless.Popover.Button>

      <Headless.Popover.Panel
        static
        className={clsx(
          "absolute z-50 rounded-md bg-zinc-900 px-2 py-1 text-xs text-white shadow-md transition-opacity",
          {
            "bottom-full left-1/2 -translate-x-1/2 mb-2": position === "top",
            "top-full left-1/2 -translate-x-1/2 mt-2": position === "bottom",
            "right-full top-1/2 -translate-y-1/2 mr-2": position === "left",
            "left-full top-1/2 -translate-y-1/2 ml-2": position === "right",
          },
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none",
          className,
        )}
      >
        {content}
      </Headless.Popover.Panel>
    </Headless.Popover>
  );
}
